import React, { useCallback } from "react";
import { View, ViewStyle, StyleProp } from "react-native";
import { Button } from "../button";
import { useColorPickerModal } from "../color-picker/modal";

// This could use a rewrite with a Portal to position the picker. Take a look at the Menu component in RN Paper.
export function ColorPickerButton({
    children,
    onChange,
    style,
    buttonStyle,
    defaultColor,
    color,
    disabled = false,
}: {
    children: string;
    onChange?: (value?: string) => void;
    style?: StyleProp<ViewStyle>;
    buttonStyle?: StyleProp<ViewStyle>;
    defaultColor?: string;
    color?: string;
    disabled: boolean;
}) {
    const renderColorPickerModal = useColorPickerModal();

    const showColorPickerModal = useCallback(async () => {
        const colorPickerResponse = await renderColorPickerModal({
            color,
            defaultColor,
        });

        if (!colorPickerResponse) {
            return;
        }

        onChange(colorPickerResponse.color);
    }, [color, defaultColor, onChange, renderColorPickerModal]);

    return (
        <View style={style}>
            <Button
                onPress={() => {
                    showColorPickerModal();
                }}
                size="small"
                style={buttonStyle}
                disabled={disabled}
            >
                {children}
            </Button>
        </View>
    );
}
